import type { Translations } from "./index";

export const tr: Translations = {
  // ── EditorLayout ──────────────────────────────────────────
  "preview.missingQuestion": "Önizleme için geçerli bir questionId parametresi gereklidir.",
  "preview.loading": "Soru yükleniyor...",
  "toast.questionLoaded": "Soru yüklendi",
  "toast.questionLoadFailed": "Soru yüklenemedi. Lütfen tekrar deneyin.",
  "toast.templateLoading": "şablonu yükleniyor...",
  "toast.templateDataNotFound": "Şablon verisi alınamadı",
  "toast.templateLoaded": "şablonu yüklendi",
  "toast.templateLoadError": "Şablon yüklenirken bir hata oluştu",
  "toast.draftCreated": "Yeni taslak oluşturuldu!",
  "toast.draftUpdated": "Taslak başarıyla güncellendi!",
  "toast.draftSaved": "Taslak başarıyla kaydedildi!",
  "toast.draftSaveFailed": "Taslak kaydedilemedi",
  "toast.draftSaveError": "Taslak kaydedilemedi. Lütfen tekrar deneyin.",
  "toast.templateCreated": "Yeni şablon oluşturuldu!",
  "toast.templateUpdated": "Şablon başarıyla güncellendi!",
  "toast.templateSaved": "Şablon başarıyla kaydedildi!",
  "toast.templateSaveFailed": "Şablon kaydedilemedi",
  "toast.templateSaveError": "Şablon kaydedilemedi. Lütfen tekrar deneyin.",
  "toast.normalSaveSettingsRequired": "Normal kaydetmeden önce soru ayarlarını tamamlayın.",
  "toast.questionCreated": "Yeni soru oluşturuldu!",
  "toast.questionUpdated": "Soru başarıyla güncellendi!",
  "toast.questionSaved": "Soru başarıyla kaydedildi!",
  "toast.questionSaveFailed": "Soru kaydedilemedi",
  "toast.questionSaveError": "Soru kaydedilemedi. Lütfen tekrar deneyin.",
  "toast.canvasCleared": "Canvas temizlendi",
  "toast.shortcutAdded": "toolbar'a eklendi",
  "toast.shortcutRemoved": "toolbar'dan kaldırıldı",
  "confirm.clearCanvas": "Tüm elementleri silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
  "overlay.redirecting": "Yönlendiriliyor...",
  "overlay.loading": "Yükleniyor...",
  "header.title": "Soru Editörü",
  "header.clearCanvas": "Canvas'ı Temizle",
  "header.canvasSettings": "Canvas Ayarları",
  "header.questionSettings": "Soru Ayarları",
  "header.answerKey": "Cevap Anahtarı",
  "header.preview": "Önizleme",
  "header.save": "Kaydet",
  "header.questionLoading": "Soru yükleniyor...",
  "panel.questionType.title": "Soru Tipi",
  "panel.questionType.loading": "Soru tipleri yükleniyor...",
  "panel.questionType.empty": "Tanımlı soru tipi bulunamadı.",
  "panel.questionType.selectedFallback": "Seçili Tip",
  "panel.questionType.unnamed": "Adsız Tip",
  "panel.elements.title": "Ögeler",
  "panel.elements.noTypeHelp": "Form elemanlarını etkinleştirmek için soru tipini seçin. Temel öğeler her zaman kullanılabilir.",
  "panel.properties.title": "Öge Ayarları",
  "panel.templates.button": "📄 Şablonlar",
  "save.draft.createTitle": "Taslak Olarak Kaydet",
  "save.draft.createSubtitle": "Henüz tamamlanmamış soruları kaydet",
  "save.draft.updateTitle": "Taslağı Güncelle",
  "save.draft.updateSubtitle": "Mevcut taslak kaydını güncelle",
  "save.draft.duplicateTitle": "Yeni Taslak Olarak Kaydet",
  "save.draft.duplicateSubtitle": "Bu sürümü yeni bir taslak olarak sakla",
  "save.template.createTitle": "Şablon Olarak Kaydet",
  "save.template.createSubtitle": "Tekrar kullanılabilir şablon oluştur",
  "save.template.updateTitle": "Şablonu Güncelle",
  "save.template.updateSubtitle": "Mevcut şablonu güncelle",
  "save.template.duplicateTitle": "Yeni Şablon Olarak Kaydet",
  "save.template.duplicateSubtitle": "Bu düzeni yeni bir şablon olarak sakla",
  "save.normal.createTitle": "Normal Kaydet",
  "save.normal.createSubtitle": "Yayına hazır soruyu kaydet",
  "save.normal.createSubtitleDisabled": "Normal kaydetmek için soru ayarlarını tamamlayın",
  "save.normal.updateTitle": "Soruyu Güncelle",
  "save.normal.updateSubtitle": "Yayındaki soruyu güncelle",
  "save.normal.duplicateTitle": "Yeni Soru Olarak Kaydet",
  "save.normal.duplicateSubtitle": "Bu çalışma ile yeni bir soru oluştur",
  "save.updateDisabledHint": "Güncellemek için önce değişiklik yapın",
  "save.duplicateDisabledHint": "Yeni soru oluşturmak için önce değişiklik yapın",
  "contextMenu.style": "Stil",
  "contextMenu.bold": "Kalın (Bold)",
  "contextMenu.italic": "İtalik",
  "contextMenu.underline": "Altı Çizili",
  "contextMenu.openInEditor": "Editörde Aç",
  "contextMenu.textToSpeech": "Metni Seslendir",
  "contextMenu.permanentDelete": "Kalıcı Olarak Sil",
  "contextMenu.placeBehindText": "Metnin arkasına yerleştir (üzerine gelince çal)",
  "contextMenu.placeBehindTextDone": "Ses, metnin arkasına yerleştirildi. Önizlemede metnin üzerine gelince çalacak.",
  "contextMenu.placeBehindTextMissing": "Bu sesin kaynağı olan metin bulunamadı.",
  "contextMenu.duplicate": "Kopyala",
  "contextMenu.delete": "Sil",
  "tts.title": "Metni Sese Dönüştür",
  "tts.subtitle": "Seçili metin bloğu ElevenLabs ile ses dosyasına çevrilecek.",
  "tts.text": "Metin",
  "tts.voiceId": "Ses Karakteri",
  "tts.voiceIdPlaceholder": "ElevenLabs voice_id",
  "tts.selectVoice": "Ses karakteri seçin",
  "tts.name": "Dosya Adı",
  "tts.namePlaceholder": "Örn. soru-seslendirme",
  "tts.modelId": "Model",
  "tts.languageCode": "Dil",
  "tts.outputFormat": "Çıktı Formatı",
  "tts.outputFormatPlaceholder": "Backend varsayılanını kullan",
  "tts.speed": "Ses Hızı",
  "tts.cancel": "Vazgeç",
  "tts.generate": "Seslendir",
  "tts.generating": "Seslendiriliyor...",
  "tts.success": "Ses dosyası oluşturuldu ve sahneye eklendi.",
  "tts.error": "Ses dosyası oluşturulamadı.",
  "tts.emptyTextError": "Seslendirilecek metin bulunamadı.",
  "tts.missingUrlError": "Backend ses dosyası URL'i döndürmedi.",
  "tts.generatedAudioLabel": "Seslendirme",
  "tts.deleteConfirm": "Bu ses dosyasını medya kütüphanesinden kalıcı olarak silmek istediğinize emin misiniz?",
  "tts.deleteSuccess": "Ses dosyası kalıcı olarak silindi.",
  "tts.deleteError": "Ses dosyası silinemedi.",
  "tts.deleteMissingPathError": "Silinecek ses dosyasının path bilgisi bulunamadı.",

  // ── Toolbar ───────────────────────────────────────────────
  "toolbar.edit": "Düzenle",
  "toolbar.undo": "Geri al (Ctrl/Cmd+Z)",
  "toolbar.redo": "İleri al (Ctrl/Cmd+Shift+Z)",
  "toolbar.grouping": "Gruplama",
  "toolbar.group": "Grupla",
  "toolbar.ungroup": "Grubu Çöz",
  "toolbar.alignment": "Hizalama",
  "toolbar.alignLeft": "Sola hizala",
  "toolbar.alignCenterH": "Yatay ortalama",
  "toolbar.alignRight": "Sağa hizala",
  "toolbar.alignTop": "Üste hizala",
  "toolbar.alignCenterV": "Dikey ortalama",
  "toolbar.alignBottom": "Alta hizala",
  "toolbar.alignToCanvas": "Canvas'a Hizala",
  "toolbar.alignCanvasLeft": "Canvas'ın soluna hizala",
  "toolbar.alignCanvasCenterH": "Canvas'ın yatay ortasına hizala",
  "toolbar.alignCanvasRight": "Canvas'ın sağına hizala",
  "toolbar.alignCanvasTop": "Canvas'ın üstüne hizala",
  "toolbar.alignCanvasCenterV": "Canvas'ın dikey ortasına hizala",
  "toolbar.alignCanvasBottom": "Canvas'ın altına hizala",
  "toolbar.guides": "Kılavuzlar",
  "toolbar.toggleRulers": "Cetvelleri göster veya gizle",
  "toolbar.toggleGuides": "Kılavuzları göster veya gizle",
  "toolbar.addVerticalGuide": "Dikey kılavuz ekle",
  "toolbar.addHorizontalGuide": "Yatay kılavuz ekle",
  "toolbar.clearGuides": "Kılavuzları temizle",
  "toolbar.guidePresets": "Şablonlar",
  "toolbar.guidePresetPlaceholder": "Şablon uygula",
  "toolbar.guidePresetMargin50": "50 px kenar boşluğu",
  "toolbar.guidePresetCenter": "Orta eksenler",
  "toolbar.guidePresetColumns3": "Üç kolon",
  "toolbar.guidePresetRows3": "Üç satır",
  "guides.addVerticalFromRuler": "Cetvelden dikey kılavuz ekle",
  "guides.addHorizontalFromRuler": "Cetvelden yatay kılavuz ekle",
  "guides.moveOrRemove": "Kılavuzu taşıyın. Silmek için çift tıklayın veya Delete tuşuna basın.",

  // ── Properties Panel ──────────────────────────────────────
  "props.noElementSelected": "Bir öge seçildiğinde özellikler burada görünecek.",
  "props.cellElementIndicatorTitle": "Hücre İçi Öğe",
  "props.cellElementIndicatorDesc": "Tablo içindeki bir öğenin özelliklerini düzenliyorsunuz",
  "props.layers": "Katmanlar",
  "props.layerMoveUp": "Bir katman üste taşı",
  "props.layerMoveDown": "Bir katman alta indir",
  "props.general": "Genel",
  "props.generalSettings": "Genel Ayarlar",
  "props.elementId": "Öge ID",
  "props.type": "Tip",
  "props.positionPx": "Konum (px)",
  "props.zIndex": "Katman (Z-Index)",
  "props.rotation": "Dönüş (°)",
  "props.appearanceTiming": "Görünüm Zamanlaması",
  "props.appearOrder": "Sıra (boşsa anında görünür)",
  "props.appearOrderPlaceholder": "boş = anında",
  "props.appearDelaySeconds": "Önceki öğeden sonra bekleme (sn)",
  "props.minDisplaySeconds": "Sonraki öğeye geçmeden bekleme (sn)",
  "props.transparent": "Şeffaf",
  "props.color": "Renk",
  "props.background": "Arkaplan",
  "props.backgroundColor": "Arkaplan Rengi",
  "props.border": "Kenarlık",
  "props.borderWidth": "Kenarlık Kalınlığı",
  "props.borderColor": "Kenarlık Rengi",
  "props.borderRadius": "Köşe Yuvarlaklığı",
  "props.borderStyle": "Kenarlık Stili",
  "props.thickness": "Kalınlık",
  "props.corner": "Köşe",
  "props.padding": "İç Boşluk",
  "props.paddingX": "İç Boşluk X",
  "props.paddingY": "İç Boşluk Y",
  "props.horizontalPadding": "Yatay İç Boşluk",
  "props.verticalPadding": "Dikey İç Boşluk",
  "props.horizontalSpacing": "Yatay Boşluk",
  "props.verticalSpacing": "Dikey Boşluk",
  "props.horizontalMargin": "Yatay Dış Boşluk",
  "props.verticalMargin": "Dikey Dış Boşluk",
  "props.fontFamily": "Font Ailesi",
  "props.fontSize": "Yazı Boyutu",
  "props.size": "Boyut",
  "props.width": "Genişlik",
  "props.height": "Yükseklik",
  "props.opacity": "Opaklık",
  "props.alignment": "Hizalama",
  "props.textAlign": "Metin Hizalama",
  "props.left": "Sol",
  "props.center": "Orta",
  "props.right": "Sağ",
  "props.justify": "İki Yana",
  "props.default": "Varsayılan",
  "props.label": "Etiket",
  "props.textColor": "Yazı Rengi",
  "props.textColorHover": "Yazı Rengi (Hover)",
  "props.textColorActive": "Yazı Rengi (Seçili)",
  "props.image": "Resim",
  "props.visual": "Görsel",
  "props.none": "Yok",
  "props.textSettings": "Metin Ayarları",
  "props.textContent": "Metin İçeriği",
  "props.style": "Stil",
  "props.bold": "Kalın",
  "props.italic": "İtalik",
  "props.underline": "Altı Çizili",
  "props.lineHeight": "Satır Yüksekliği",
  "props.letterSpacing": "Harf Aralığı",
  "props.textTransform": "Metin Dönüşümü",
  "props.shadow": "Gölge",
  "props.borderStyleSolid": "Düz",
  "props.borderStyleDashed": "Kesikli",
  "props.borderStyleDotted": "Noktalı",
  "props.borderStyleFull": "Tam Kenar",
  "props.borderStyleBottom": "Alt Kenar",
  "props.fillInTheBlanksSettings": "Boşluk Doldurma Ayarları",
  "props.fillInTheBlanksContent": "İçerik (Cevapları [köşeli parantez] içine yazın)",
  "props.fillInTheBlanksPlaceholder": "Örnek: Türkiye'nin başkenti [Ankara]'dır.",
  "props.hideCorrectAnswers": "Doğru Cevapları Gizle",
  "props.hideCorrectAnswersHelp": "Bu seçenek aktif olduğunda, canvas üzerinde doğru cevaplar (köşeli parantez içindeki değerler) gizlenir.",
  "props.blankChoicesDropdown": "Boşluk Seçenekleri (Dropdown)",
  "props.blankChoicesHelp": "Her boşluk için seçenekler verirseniz, öğrenciler dropdown menüden seçim yapacaktır. Seçenek verilmezse metin girişi olur.",
  "props.dropdownActive": "Dropdown Aktif",
  "props.addNewChoice": "Yeni seçenek ekle...",
  "props.applyToAllBlanks": "Tüm boşluklara uygula",
  "props.boxBackground": "Kutu Arkaplanı",
  "props.boxBorder": "Kutu Kenarlığı",
  "props.boxTextColor": "Kutu Metin Rengi",
  "props.text": "Metin",
  "props.blankDefaultWidth": "Boşluk Varsayılan Genişliği (px)",
  "props.blankFontFamily": "Boşluk Font Ailesi",
  "props.blankFontSize": "Boşluk Font Boyutu",
  "props.blankFontStyles": "Boşluk Font Stilleri",
  "props.blankLetterSpacing": "Boşluk Harf Aralığı",
  "props.imageSettings": "Resim Ayarları",
  "props.imageClickToChange": "Resmi değiştirmek için tıklayın",
  "props.imageSelectFromLibrary": "Medya kütüphanesinden resim seçin",
  "props.imageSelected": "Resim Seçildi (Değiştir)",
  "props.selectFromMediaLibrary": "Medya Kütüphanesinden Seç",
  "props.viewCurrentImage": "Mevcut resmi görüntüle",
  "props.altText": "Alt Metin",
  "props.objectFit": "Sığdırma Modu",
  "props.objectFitContain": "İçine Sığdır",
  "props.objectFitCover": "Kapla",
  "props.objectFitFill": "Doldur",
  "props.objectFitNone": "Orijinal Boyut",
  "props.objectFitScaleDown": "Küçült",
  "props.imagePosition": "Resim Konumu",
  "props.posCenter": "Merkez",
  "props.posTop": "Üst",
  "props.posBottom": "Alt",
  "props.posTopLeft": "Sol Üst",
  "props.posTopRight": "Sağ Üst",
  "props.posBottomLeft": "Sol Alt",
  "props.posBottomRight": "Sağ Alt",
  "props.posTopCenter": "Üst Orta",
  "props.posRightCenter": "Sağ Orta",
  "props.autoSizeHelp": "Boş bırakıldığında otomatik boyutlandırma kullanılır.",
  "props.imageScaling": "Görsel Ölçekleme",
  "props.fitting": "Sığdırma",
  "props.audioSettings": "Ses Ayarları",
  "props.audioUrl": "Ses URL'si",
  "props.audioClickToChange": "Ses dosyasını değiştirmek için tıklayın",
  "props.audioSelectFromLibrary": "Ses kütüphanesinden ses dosyası seçin",
  "props.audioSelected": "Ses Dosyası Seçildi (Değiştir)",
  "props.audioSelectFromSoundLibrary": "Ses Kütüphanesinden Seç",
  "props.audioUrlHelp": "Geçerli bir .mp3, .wav veya desteklenen ses dosyası URL'si girin.",
  "props.showIcon": "İkonu göster",
  "props.showLabel": "Etiketi göster",
  "props.visibleLabel": "Görünen Etiket",
  "props.audioPlayPlaceholder": "Ses dosyasını çal",
  "props.autoPlay": "Sayfa açıldığında otomatik çal (önizleme)",
  "props.loop": "Döngüde çal",
  "props.showControls": "Tarayıcı kontrollerini göster",
  "props.iconColor": "İkon Rengi",
  "props.videoSettings": "Video Ayarları",
  "props.videoClickToChange": "Video dosyasını değiştirmek için tıklayın",
  "props.videoSelectFromLibrary": "Medya kütüphanesinden video seçin",
  "props.videoSelected": "Video Seçildi (Değiştir)",
  "props.options": "Seçenekler",
  "props.multipleSelection": "Çoklu Seçim",
  "props.deleteOption": "Seçeneği sil",
  "props.contentType": "İçerik Türü",
  "props.contentTypeText": "Metin",
  "props.contentTypeImage": "Görsel",
  "props.contentTypeMath": "Matematik (MathType)",
  "props.optionTextPlaceholder": "Seçenek metni...",
  "props.addOption": "+ Seçenek Ekle",
  "props.layout": "Düzen",
  "props.layoutDirection": "Yerleşim",
  "props.layoutVertical": "Dikey",
  "props.layoutHorizontal": "Yatay",
  "props.gridColumns": "Sütun Sayısı",
  "props.optionSpacing": "Seçenek Aralığı",
  "props.uniformWidth": "Eşit Genişlik",
  "props.uniformWidthLabel": "Seçenekleri Eşit Genişlikte Yap",
  "props.optionPrefix": "Seçenek Öneki",
  "props.textStyle": "Yazı Stili",
  "props.fontWeight": "Kalınlık",
  "props.fontWeightThin": "İnce",
  "props.fontWeightNormal": "Normal",
  "props.fontWeightMedium": "Orta Kalın",
  "props.fontWeightBold": "Kalın",
  "props.fontWeightSemiBold": "Orta Kalın",
  "props.fontWeightExtraBold": "Ekstra Kalın",
  "props.colors": "Renkler",
  "props.backgroundHover": "Arkaplan (Hover)",
  "props.backgroundActive": "Arkaplan (Seçili)",
  "props.borderAndSpacing": "Kenarlık & Boşluk",
  "props.borderColorHover": "Kenarlık Rengi (Hover)",
  "props.borderColorActive": "Kenarlık Rengi (Seçili)",
  "props.indicator": "Gösterge",
  "props.showIndicator": "Göstergeyi Göster",
  "props.indicatorColor": "Gösterge Rengi",
  "props.indicatorColorActive": "Gösterge Rengi (Seçili)",
  "props.icons": "İkonlar",
  "props.showIcons": "İkonları Göster",
  "props.position": "Pozisyon",
  "props.iconSize": "İkon Boyutu",
  "props.advancedSettings": "Gelişmiş Ayarlar",
  "props.valueId": "Değer (ID)",
  "props.iconUrl": "İkon URL",
  "props.iconUrlChecked": "İkon URL (Seçili)",
  "props.iconUrlNormal": "İkon URL (Normal)",
  "props.disabled": "Devre Dışı",
  "props.mathmlFormula": "MathML Formülü",
  "props.openEditor": "Editör Aç",
  "props.contentAlignment": "İçerik Hizalama",
  "props.horizontal": "Yatay",
  "props.vertical": "Dikey",
  "props.dragSourceSettings": "Sürüklenebilir Öğe Ayarları",
  "props.elementLabel": "Öğe",
  "props.idReadOnly": "ID (Değiştirilemez)",
  "props.appearanceSettings": "Görünüm Ayarları",
  "props.visualContent": "Görsel İçerik",
  "props.behaviorSettings": "Davranış Ayarları",
  "props.maxCopyCount": "Maksimum kopya sayısı",
  "props.numberBackground": "Numara Arkaplanı",
  "props.topLeft": "Üst Sol",
  "props.topCenter": "Üst Orta",
  "props.topRight": "Üst Sağ",
  "props.bottomRight": "Alt Sağ",
  "props.dropTargetSettings": "Hedef Alan Ayarları",
  "props.acceptedElements": "Kabul Edilen Öğeler",
  "props.noElementAccepted": "Hiçbir öğe seçili değil - tüm öğeler kabul edilir",
  "props.labelSettings": "Etiket Ayarları",
  "props.labelTextColor": "Etiket Yazı Rengi",
  "props.labelColor": "Etiket Rengi",
  "props.labelBackground": "Etiket Arka Planı",
  "props.altTextOptional": "Alternatif Metin (opsiyonel)",
  "props.backgroundImageLabel": "Arka Plan Görseli",
  "props.blankLabel": "Boşluk",
  "props.cloneable": "Sınırsız Kopyalanabilir",
  "props.colorActive": "Aktif Renk",
  "props.dropAreaCoordinatesHint": "Bırakma alanının konum ve boyutu",
  "props.dropTargetPlaceholderText": "Yer Tutucu Metni",
  "props.emptyMessageHint": "Alan boşken gösterilecek mesaj",
  "props.highlightColor": "Vurgu Rengi",
  "props.highlightOnDrag": "Sürüklerken Vurgula",
  "props.nameShownInAnswerKey": "Bu isim cevap anahtarında gösterilir",
  "props.option": "Seçenek",
  "props.restrictDropArea": "Bırakma Alanını Sınırla",
  "props.showAsImage": "Görsel İçeriği Göster",
  "props.showAsShape": "Görsel İçeriği Geometrik Şekil Olarak Göster",
  "props.showDropAreaOutline": "Bırakma Alanı Çerçevesini Göster",
  "props.showEmptyMessage": "Boş Mesajını Göster",
  "props.showLess": "Daha Az Göster",
  "props.showNumberingInTarget": "Hedefte Numaralandırmayı Göster",
  "props.sourceColor": "Kaynak Rengi",
  "props.targetColor": "Hedef Rengi",
  "props.unlimitedCopiesHint": "Öğe sınırsız kez sürüklenebilir",
  "props.videoUrlHelp": "Video bağlantısını (URL) yapıştırın",
  "props.labelHorizontalPadding": "Etiket Yatay İç Boşluk",
  "props.labelVerticalPadding": "Etiket Dikey İç Boşluk",
  "props.labelCornerRadius": "Etiket Köşe Yuvarlaklığı",
  "props.contentLayout": "İçerik Düzeni",
  "props.contentPlacement": "İçerik Yerleşimi",
  "props.start": "Başlangıç",
  "props.itemSpacing": "Öğe Arası Boşluk",
  "props.enableBackgroundImage": "Arka plan resmini etkinleştir",
  "props.dropArea": "Bırakma Alanı",
  "props.frameColor": "Çerçeve Rengi",
  "props.frameWidth": "Çerçeve Kalınlığı",
  "props.orderListSettings": "Sıralama Alanı Ayarları",
  "props.orderListArea": "Sıralama Alanı",
  "props.elements": "Öğeler",
  "props.elementLabelPlaceholder": "Öğe etiketi",
  "props.deleteElement": "Öğeyi Sil",
  "props.labelRounding": "Etiket Yuvarlaklık",
  "props.labelPaddingH": "Etiket İç Boşluk (Yatay)",
  "props.labelPaddingV": "Etiket İç Boşluk (Dikey)",
  "props.borderRoundness": "Kenarlık Yuvarlaklığı",
  "props.paddingH": "İç Boşluk (Yatay)",
  "props.paddingV": "İç Boşluk (Dikey)",
  "props.itemGap": "Öğe Arası Boşluk",
  "props.itemBackgroundColor": "Öğe Arkaplan Rengi",
  "props.itemBorderColor": "Öğe Kenarlık Rengi",
  "props.itemTextColor": "Öğe Metin Rengi",
  "props.itemFontSize": "Öğe Yazı Boyutu",
  "props.itemBorderWidth": "Öğe Kenarlık Kalınlığı",
  "props.itemBorderRadius": "Öğe Kenarlık Yuvarlaklığı",
  "props.itemPaddingH": "Öğe İç Boşluk (Yatay)",
  "props.itemPaddingV": "Öğe İç Boşluk (Dikey)",
  "props.matchingPointSettings": "Eşleştirme Noktası Ayarları",
  "props.name": "İsim",
  "props.sourcePointName": "Kaynak Noktası İsmi",
  "props.targetPointName": "Hedef Noktası İsmi",
  "props.pointSettings": "Nokta Ayarları",
  "props.borderThickness": "Border Kalınlığı",
  "props.sourceBorderColor": "Kaynak Kenarlık Rengi",
  "props.connectionColor": "Bağlantı Rengi",
  "props.connectionWidth": "Bağlantı Kalınlığı",
  "props.connectionStyle": "Bağlantı Stili",
  "props.targetBorderColor": "Hedef Kenarlık Rengi",
  "props.paintAreaSettings": "Boyama Alanı Ayarları",
  "props.shapeName": "Şekil Adı",
  "props.shapeNamePlaceholder": "Örn: A Dairesi",
  "props.shapeType": "Şekil Tipi",
  "props.star": "Yıldız",
  "props.triangle": "Üçgen",
  "props.pentagon": "Beşgen",
  "props.hexagon": "Altıgen",
  "props.flower": "Çiçek",
  "props.sun": "Güneş",
  "props.paintSwatchSettings": "Renk Alanı Ayarları",
  "props.pushToTalkSettings": "Bas Konuş Ayarları",
  "props.buttonDimensions": "Buton Boyutları",
  "props.buttonSizePx": "Buton (px)",
  "props.contentSizePx": "İçerik (px)",
  "props.textSizePx": "Metin (px)",
  "props.canvasStatus": "Canvas Durumu",
  "props.idle": "Beklemede",
  "props.listening": "Dinlerken",
  "props.error": "Hata",
  "props.canvasStatusHelp": "Bu ayar sadece düzenleme sırasında canvas görünümünü değiştirir.",
  "props.micButton": "Mikrofon Butonu",
  "props.errorAlert": "Hata Uyarısı",
  "props.textArea": "Yazı Alanı",
  "props.textAreaTitle": "Yazı Alanı Başlığı",
  "props.errorMessagePreview": "Hata Mesajı (Önizleme)",
  "props.errorMessagePlaceholder": "Örn: Mikrofon izni reddedildi.",
  "props.textAreaLabel": "Yazı Alanı Label",
  "props.textAreaLabelPlaceholder": "Kaydedilen Cevap",
  "props.textAreaPlaceholder": "Yazı Alanı Placeholder",
  "props.errorBackground": "Hata Zemin",
  "props.errorBorder": "Hata Çerçeve",
  "props.errorText": "Hata Yazı",
  "props.buttonShape": "Buton Şekli",
  "props.shape": "Şekil",
  "props.shapeCircle": "Daire",
  "props.shapeSquare": "Kare",
  "props.roundness": "Yuvarlaklık",
  "props.buttonColors": "Buton Renkleri",
  "props.waiting": "Bekleme",
  "props.listeningColor": "Dinleme",
  "props.buttonTextColors": "Buton Yazı Renkleri",
  "props.waveColor": "Dalga Rengi",
  "props.buttonContent": "Buton İçeriği",
  "props.contentTypeLabel": "Tür",
  "props.iconDefault": "İkon (varsayılan)",
  "props.visualMedia": "Görsel (Medya)",
  "props.idleButtonText": "Butonda görünecek metin",
  "props.selectVisual": "Görsel Seç",
  "props.remove": "Kaldır",
  "props.preview": "Önizle",
  "props.empty": "Boş",
  "props.clearAll": "Tümünü Temizle",
  "props.errorPlaceholderHelp": "Bu ayar artık Canvas Durumu = Hata seçiliyken, yukarıdaki \"Yazı Alanı Placeholder\" alanından düzenleniyor.",
  "props.errorPlaceholderTitle": "Hata durumunda yazı alanı placeholder",
  "props.mathSettings": "Matematik Ayarları",
  "props.tableSettings": "Tablo Ayarları",
  "props.row": "Satır",
  "props.column": "Sütun",
  "props.spacings": "Boşluklar (px)",
  "props.cellPadding": "Hücre İç Boşluğu",
  "props.cellBackgroundColor": "Hücre Arka Plan Rengi",
  "props.timerSettings": "Zamanlayıcı Ayarları",
  "props.durationSeconds": "Süre (Saniye)",
  "props.displayFormat": "Görünüm Formatı",
  "props.formatMinSec": "Dakika:Saniye (mm:ss)",
  "props.formatSec": "Saniye (ss)",
  "props.continueAfterExpiry": "Süre bittiğinde cevap vermeye devam edilsin",
  "props.autoSubmitOnExpiry": "Süre bittiğinde otomatik gönder",
  "props.buttonSettings": "Buton Ayarları",
  "props.buttonText": "Buton Metni",
  "props.showNumbers": "Numaralandırma",
  "props.numberPosition": "Numara Pozisyonu",
  "props.numberColor": "Numara Rengi",
  "props.numberBgColor": "Numara Arkaplan",

  // ── Constants ─────────────────────────────────────────────
  "constants.section.basic": "Temel",
  "constants.section.formElements": "Form Elemanları",
  "constants.element.textBlock": "Metin Bloğu",
  "constants.element.image": "Resim",
  "constants.element.audioFile": "Ses Dosyası",
  "constants.element.slideVideo": "Slayt (Video)",
  "constants.element.mathEditor": "Matematik Editörü (MathType)",
  "constants.element.table": "Tablo",
  "constants.element.shape": "Geometrik Şekil",
  "constants.element.countArea": "Tıklayarak Sayma",
  "constants.element.keypadOneToFive": "Klavye (1-5)",
  "constants.element.keypadZeroToNine": "Klavye (0-9)",
  "constants.element.keypadMath": "Klavye (Matematik)",
  "constants.element.playButton": "Oynat (Sesli Metin)",
  "constants.element.cubeBar5": "Küp Çubuğu (5)",
  "constants.element.cubeBar10": "Küp Çubuğu (10)",
  "constants.element.cubeSource": "Küp Kaynağı",
  "constants.element.colorPalette": "Renk Kartelası",
  "constants.element.multipleChoice": "Çoktan Seçmeli",
  "constants.element.draggableItem": "Sürüklenebilir Öğe",
  "constants.element.targetArea": "Hedef Alan",
  "constants.element.orderingArea": "Sıralama Alanı",
  "constants.element.sourcePoint": "Kaynak Noktası",
  "constants.element.targetPoint": "Hedef Noktası",
  "constants.element.matching2Pairs": "Eşleştirme 2 Çift",
  "constants.element.matching3Pairs": "Eşleştirme 3 Çift",
  "constants.element.matching4Pairs": "Eşleştirme 4 Çift",
  "constants.element.fillInTheBlanks": "Boşluk Doldurma",
  "constants.element.paintArea": "Boyama Alanı",
  "constants.element.colorSwatch": "Renk Alanı",
  "constants.element.pushToTalk": "Bas Konuş",

  // ── Appearance defaults ───────────────────────────────────
  "appearance.image.alt": "Resim",
  "appearance.audio.label": "Ses dosyasını çal",
  "appearance.pushToTalk.instructionText": "Basılı tutup konuşun, sesiniz metne çevrilecektir.",
  "appearance.pushToTalk.idleButtonText": "Bas Konuş",
  "appearance.pushToTalk.listeningButtonText": "Dinleniyor...",
  "appearance.pushToTalk.processingButtonText": "Metne Çevriliyor...",
  "appearance.pushToTalk.transcriptionLabel": "Kaydedilen Cevap",
  "appearance.pushToTalk.transcriptionPlaceholder": "Ses kaydı alınamadı. Lütfen cevabınızı buraya yazın.",
  "appearance.pushToTalk.errorPreviewMessage": "Ses kaydı alınamadı. Lütfen mikrofon izinlerini ve tarayıcı ayarlarınızı kontrol edin.",
  "appearance.pushToTalk.oldPlaceholder": "Ses kaydınız otomatik olarak metne dönüştürülecek.",

  // ── Templates ─────────────────────────────────────────────
  "templates.text.defaultContent": "Yeni metin",
  "templates.choice.optionA": "Seçenek A",
  "templates.choice.optionB": "Seçenek B",
  "templates.choice.optionC": "Seçenek C",
  "templates.choice.optionD": "Seçenek D",
  "templates.dragSource.label": "Öğe",
  "templates.dropTarget.label": "Hedef Alan",
  "templates.dropTarget.placeholder": "Boş alan",
  "templates.orderList.label": "Sıralama Alanı",
  "templates.orderList.placeholder": "Öğeleri sıralayın",
  "templates.orderList.item1": "Öğe 1",
  "templates.orderList.item2": "Öğe 2",
  "templates.orderList.item3": "Öğe 3",

  // ── Validation ────────────────────────────────────────────
  "validation.feedback.perfect": "Mükemmel! Tüm soruları doğru yanıtladınız.",
  "validation.feedback.success": "Başarılı!",
  "validation.feedback.fail": "Geçme puanına ulaşamadınız.",
  "validation.result.correct": "Doğru!",
  "validation.result.partiallyCorrect": "Kısmen doğru",
  "validation.result.wrong": "Yanlış",
  "validation.canvas.noElements": "Canvas üzerinde en az bir eleman bulunmalıdır.",
  "validation.choice.noAnswerKey": "Seçim soruları için cevap anahtarı doldurulmalıdır. Lütfen \"Cevap Anahtarı\" bölümünden doğru cevapları belirleyin.",
  "validation.dragDrop.noAnswerKey": "Sürükle-bırak hedef alanları için cevap anahtarı doldurulmalıdır. Lütfen \"Cevap Anahtarı\" bölümünden kabul edilecek öğeleri belirleyin.",
  "validation.orderList.noAnswerKey": "Sıralama alanları için cevap anahtarı doldurulmalıdır. Lütfen \"Cevap Anahtarı\" bölümünden doğru sıralamayı belirleyin.",
  "validation.matching.noAnswerKey": "Eşleştirme soruları için cevap anahtarı doldurulmalıdır. Lütfen \"Cevap Anahtarı\" bölümünden bağlantıları belirleyin.",
  "validation.matching.noConnections": "Eşleştirme soruları için en az bir bağlantı belirlenmelidir. Lütfen \"Cevap Anahtarı\" bölümünden bağlantıları belirleyin.",
  "validation.fillInTheBlanks.noAnswerKey": "Boşluk doldurma soruları için cevap anahtarı doldurulmalıdır. Lütfen \"Cevap Anahtarı\" bölümünden doğru cevapları belirleyin.",
  "validation.painting.noAnswerKey": "Boyama soruları için cevap anahtarı doldurulmalıdır. Lütfen \"Cevap Anahtarı\" bölümünden her boyama alanı için bir renk seçin.",
  "validation.dragDrop.correctResult": "Doğru!",
  "validation.dragDrop.wrongOrderAndItems": "Yanlış sıralama veya öğeler",
  "validation.dragDrop.wrongItems": "Yanlış öğeler",
  "validation.orderList.correct": "Doğru! Sıralama tamamen doğru.",
  "validation.orderList.wrongOrder": "Yanlış sıralama",

  // ── Renderers ─────────────────────────────────────────────
  "renderers.dropTarget.placeholder": "Boş alan",
  "renderers.text.fallbackContent": "Metin içeriği",
  "renderers.image.addUrl": "Resim URL'si ekleyin",
  "renderers.choice.imagePlaceholder": "Görsel",
  "renderers.audio.fallbackLabel": "Ses dosyası",
  "renderers.audio.addUrl": "Ses URL'si ekleyin",
  "renderers.video.addUrl": "Video URL'si ekleyin",
  "renderers.dragSource.defaultLabel": "Öğe",
  "renderers.dropTarget.defaultLabel": "Hedef Alan",
  "renderers.orderList.defaultLabel": "Sıralama Alanı",
  "renderers.orderList.defaultPlaceholder": "Öğeleri sıralayın",
  "renderers.dragSource.accessibleLabel": "Sürüklenebilir öğe",
  "renderers.droppedItem.defaultLabel": "Öğe",
  "renderers.table.emptyCell": "Boş",
  "renderers.table.doubleClickToType": "çift tık ile yaz",
  "renderers.fillInTheBlanks.selectPlaceholder": "Seçiniz...",
  "renderers.pushToTalk.defaultErrorMessage": "Ses kaydı alınamadı. Lütfen cevabınızı yazın.",
  "renderers.pushToTalk.stopButtonText": "Durdur",
  "renderers.pushToTalk.startButtonText": "Başlat",
  "renderers.pushToTalk.stopTitle": "Durdurmak için tıklayın",
  "renderers.pushToTalk.startTitle": "Konuşmak için tıklayın",
  "renderers.pushToTalk.listeningAriaLabel": "Dinleniyor. Durdurmak için tıklayın.",
  "renderers.pushToTalk.idleAriaLabel": "Konuşmak için tıklayın.",
  "renderers.pushToTalk.canvasAriaLabel": "Bas konuş (önizlemede etkin)",
  "renderers.pushToTalk.canvasErrorMessage": "Ses kaydı alınamadı. Lütfen mikrofon izinlerini kontrol edin.",
  "renderers.pushToTalk.canvasTranscriptionLabel": "Kaydedilen Cevap",

  // ── Elements ──────────────────────────────────────────────
  "elements.label.textBlock": "Metin Bloğu",
  "elements.label.audioFile": "Ses Dosyası",
  "elements.label.colorPalette": "Renk Kartelası",
  "elements.label.sourcePoint": "Kaynak Noktası",
  "elements.label.targetPoint": "Hedef Noktası",

  // ── Canvas Screenshot ─────────────────────────────────────
  "canvasScreenshot.error.canvasNotFound": "Canvas element bulunamadı, screenshot alınamadı",
  "canvasScreenshot.error.previewNotFound": "Preview container bulunamadı, screenshot alınamadı",
  "canvasScreenshot.error.invalidBase64": "Geçersiz base64 formatı",

  // ── QuestionSettingsModal ─────────────────────────────────
  "questionSettings.title": "Soru Ayarları",
  "questionSettings.subtitle": "Soru meta bilgileri",
  "questionSettings.close": "Kapat",
  "questionSettings.questionType": "Soru Tipi",
  "questionSettings.notSelected": "Seçilmedi",
  "questionSettings.subject": "Ders",
  "questionSettings.grade": "Sınıf",
  "questionSettings.topic": "Konu",
  "questionSettings.subtopic": "Alt Konu",
  "questionSettings.objective": "Kazanım",
  "questionSettings.difficultyLevel": "Zorluk Seviyesi:",
  "questionSettings.solutionVideoUrl": "Çözüm Videosu (URL)",
  "questionSettings.lectureVideoUrl": "Konu Anlatım Videosu (URL)",
  "questionSettings.solutionTextUrl": "Çözüm Metni (URL)",
  "questionSettings.timeLimit": "Süre Limiti (saniye)",
  "questionSettings.trackTime": "Süre Takibi Yap",
  "questionSettings.notMobileFriendly": "Mobil'e Uygun Değil",
  "questionSettings.showInMbaExam": "MBA sınavında gösterilsin",
  "questionSettings.cancel": "İptal",
  "questionSettings.save": "Kaydet",
  "questionSettings.preview": "Önizle",
  "questionSettings.loading": "Yükleniyor...",
  "questionSettings.select": "Seçiniz",
  "questionSettings.selectSubjectFirst": "Önce ders seçin",
  "questionSettings.selectSubjectAndGradeFirst": "Önce ders ve sınıf seçin",
  "questionSettings.selectOptional": "Seçiniz (Opsiyonel)",
  "questionSettings.selectTopicFirst": "Önce konu seçin",
  "questionSettings.selectSubtopicFirst": "Önce alt konu seçin",
  "questionSettings.urlPreview": "URL önizlemesi",
  "questionSettings.openInNewTab": "Yeni sekmede aç",
  "questionSettings.videoPreview": "Video önizleme",
  "questionSettings.textPreview": "Metin önizleme",

  // ── VideoLibraryModal ─────────────────────────────────────
  "videoLibrary.fallbackName": "Video Dosyası",
  "videoLibrary.loadError": "Video kütüphanesi yüklenirken hata oluştu",
  "videoLibrary.title": "Video Kütüphanesi",
  "videoLibrary.subtitle": "Bir video dosyası seçin",
  "videoLibrary.close": "Kapat",
  "videoLibrary.loading": "Yükleniyor...",
  "videoLibrary.empty": "Video kütüphanesi boş",
  "videoLibrary.rootFolder": "Ana Klasör",
  "videoLibrary.folderEmpty": "Bu klasör boş",
  "videoLibrary.selected": "Seçildi",
  "videoLibrary.select": "Seç",
  "videoLibrary.back": "← Geri",
  "videoLibrary.cancel": "İptal",

  // ── AnswerKeyModal ────────────────────────────────────────
  "answerKey.close": "Kapat",
  "answerKey.title": "Cevap Anahtarı",
  "answerKey.subtitle": "Form elemanları için doğru cevapları belirleyin",
  "answerKey.noFormElements": "Canvas üzerinde hiç form elemanı yok. Cevap anahtarı belirlemek için önce form elemanları (seçim, sürükle-bırak, sıralama alanı, eşleştirme noktası veya boyama alanı) ekleyin.",
  "answerKey.section.choiceQuestions": "Seçim Soruları",
  "answerKey.choice.multipleSelection": "Çoklu Seçim",
  "answerKey.choice.singleSelection": "Tekli Seçim",
  "answerKey.choice.singleSelectionHint": "Tekli seçimde sadece bir doğru cevap seçebilirsiniz.",
  "answerKey.section.fillInTheBlanks": "Boşluk Doldurma Cevapları",
  "answerKey.fillInTheBlanks.label": "Boşluk Doldurma",
  "answerKey.fillInTheBlanks.noAnswers": "Tanımlanmış cevap bulunamadı.",
  "answerKey.section.pushToTalk": "Bas Konuş (Sesli Yanıt) Cevapları",
  "answerKey.pushToTalk.instruction": "Doğru kabul edilecek cevapları satır satır girin. Kullanıcı cevabı bu metinlerden biriyle eşleşirse doğru sayılabilir.",
  "answerKey.pushToTalk.noAnswers": "Henüz doğru cevap eklenmemiş.",
  "answerKey.section.paintAreas": "Boyama Alanları",
  "answerKey.paintArea.noSwatches": "Canvas üzerinde renk alanı bulunamadı. Lütfen önce renk örnekleri ekleyin.",
  "answerKey.section.intersections": "Kesişimler",
  "answerKey.intersection.noSwatches": "Canvas üzerinde renk alanı bulunamadı. Lütfen önce renk örnekleri ekleyin.",
  "answerKey.section.dragDrop": "Sürükle-Bırak Hedef Alanları",
  "answerKey.dragDrop.existingItems": "Mevcut Öğeler:",
  "answerKey.dragDrop.noItems": "Henüz sürüklenebilir öğe eklenmemiş.",
  "answerKey.dragDrop.acceptedItems": "Kabul Edilen Öğeler",
  "answerKey.dragDrop.ordered": "(Sıralı)",
  "answerKey.dragDrop.unordered": "(Sırasız)",
  "answerKey.dragDrop.orderWarning": "Sıralama önemli - Sürükleyerek sıralayın",
  "answerKey.dragDrop.removeTitle": "Kaldır",
  "answerKey.dragDrop.constraints": "Kısıtlamalar:",
  "answerKey.dragDrop.minItemCount": "Minimum Öğe Sayısı:",
  "answerKey.dragDrop.maxItemCount": "Maksimum Öğe Sayısı:",
  "answerKey.dragDrop.exactCount": "Tam Sayı (Exact):",
  "answerKey.dragDrop.orderMatters": "Sıralama Önemli",
  "answerKey.dragDrop.exactCountNote": "Not: \"Tam Sayı\" ayarlandığında min/max değerleri göz ardı edilir.",
  "answerKey.section.matching": "Eşleştirme Bağlantıları",
  "answerKey.matching.noTargets": "Henüz hedef noktası eklenmemiş. Hedef noktası ekleyin ve bağlantıları oluşturun.",
  "answerKey.matching.sourcePoint": "Kaynak Noktası",
  "answerKey.matching.availableTargets": "Bağlanabilecek Hedef Noktalar:",
  "answerKey.matching.connectedTargets": "Bağlı Hedef Noktalar (",
  "answerKey.matching.removeConnectionTitle": "Bağlantıyı Kaldır",
  "answerKey.section.orderList": "Sıralama Alanları",
  "answerKey.orderList.noItems": "Bu sıralama alanında henüz öğe eklenmemiş.",
  "answerKey.orderList.correctOrder": "Doğru Sıralama:",
  "answerKey.orderList.dragHint": "Sürükleyerek sıralayın",
  "answerKey.orderList.instruction": "Öğeleri sürükleyip bırakarak doğru sıralamayı belirleyin. Öğrenciler bu sıraya göre değerlendirilecek.",
  "answerKey.cancel": "İptal",
  "answerKey.save": "Kaydet",
  "shape.star": "Yıldız",
  "shape.circle": "Daire",
  "shape.square": "Kare",
  "shape.triangle": "Üçgen",
  "shape.heart": "Kalp",
  "shape.diamond": "Elmas",
  "shape.pentagon": "Beşgen",
  "shape.hexagon": "Altıgen",
  "shape.octagon": "Sekizgen",
  "shape.oval": "Oval",
  "shape.trapezoid": "Yamuk",
  "shape.parallelogram": "Paralelkenar",
  "shape.cloud": "Bulut",
  "shape.flower": "Çiçek",
  "shape.sun": "Güneş",

  // ── PreviewModal / FullScreenPreview ──────────────────────
  "previewModal.title": "Önizleme",
  "previewModal.close": "Kapat",
  "fullScreenPreview.title": "Önizleme",
  "fullScreenPreview.close": "Kapat",
  "fullScreenPreview.checkAnswer": "Cevabı kontrol et",
  "fullScreenPreview.allCorrect": "Tebrikler! Tüm cevaplar doğru 🎉",
  "fullScreenPreview.summary": "{correct} / {total} doğru",
  "fullScreenPreview.nothingToCheck": "Bu soruda kontrol edilecek bir cevap yok.",
  "fullScreenPreview.resultCorrect": "Doğru",
  "fullScreenPreview.resultWrong": "Yanlış",
  "fullScreenPreview.resultEmpty": "Boş bırakıldı",
  "fullScreenPreview.typeChoice": "Çoktan seçmeli",
  "fullScreenPreview.typeDragDrop": "Sürükle-bırak",
  "fullScreenPreview.typeOrderList": "Sıralama",
  "fullScreenPreview.typeMatching": "Eşleştirme",
  "fullScreenPreview.typeFillBlanks": "Boşluk doldurma",
  "fullScreenPreview.typePaint": "Boyama",

  // ── TemplateNameModal ─────────────────────────────────────
  "templateName.titleNew": "Yeni Şablon Olarak Kaydet",
  "templateName.titleEdit": "Şablon Olarak Kaydet",
  "templateName.subtitle": "Şablon için bir isim girin",
  "templateName.close": "Kapat",
  "templateName.nameLabel": "Şablon İsmi",
  "templateName.namePlaceholder": "Örn: Matematik Soru Şablonu",
  "templateName.tagsLabel": "Etiketler",
  "templateName.noTagsSelected": "Seçili etiket yok.",
  "templateName.searchPlaceholder": "Etiket ara veya ekle",
  "templateName.noMatchingTags": "Eşleşen etiket bulunamadı.",
  "templateName.tagHelp": "Birden fazla etiket seçebilir veya yeni etiket ekleyebilirsiniz.",
  "templateName.cancel": "İptal",
  "templateName.save": "Kaydet",

  // ── TemplatesModal ────────────────────────────────────────
  "templatesModal.fallbackName": "İsimsiz Şablon",
  "templatesModal.title": "Şablonlar",
  "templatesModal.subtitle": "Bir şablon seçerek hızlıca başlayın",
  "templatesModal.close": "Kapat",
  "templatesModal.searchPlaceholder": "Şablon veya etiket ara...",
  "templatesModal.noSearchResults": "Arama sonucu bulunamadı",
  "templatesModal.noTemplates": "Şablon bulunamadı",
  "templatesModal.noTags": "Etiketsiz",
  "templatesModal.altFallback": "Şablon",
  "templatesModal.cancel": "İptal",

  // ── MediaLibraryModal ─────────────────────────────────────
  "mediaLibrary.fallbackName": "Resim Dosyası",
  "mediaLibrary.loadError": "Medya kütüphanesi yüklenirken hata oluştu",
  "mediaLibrary.title": "Medya Kütüphanesi",
  "mediaLibrary.subtitle": "Bir resim seçin",
  "mediaLibrary.close": "Kapat",
  "mediaLibrary.loading": "Yükleniyor...",
  "mediaLibrary.empty": "Medya kütüphanesi boş",
  "mediaLibrary.rootFolder": "Ana Klasör",
  "mediaLibrary.folderEmpty": "Bu klasör boş",
  "mediaLibrary.back": "← Geri",
  "mediaLibrary.cancel": "İptal",

  // ── SoundLibraryModal ─────────────────────────────────────
  "soundLibrary.fallbackName": "Ses Dosyası",
  "soundLibrary.loadError": "Ses kütüphanesi yüklenirken hata oluştu",
  "soundLibrary.title": "Ses Kütüphanesi",
  "soundLibrary.subtitle": "Bir ses dosyası seçin",
  "soundLibrary.close": "Kapat",
  "soundLibrary.loading": "Yükleniyor...",
  "soundLibrary.empty": "Ses kütüphanesi boş",
  "soundLibrary.rootFolder": "Ana Klasör",
  "soundLibrary.folderEmpty": "Bu klasör boş",
  "soundLibrary.stop": "Durdur",
  "soundLibrary.play": "Dinle",
  "soundLibrary.back": "← Geri",
  "soundLibrary.cancel": "İptal",
  "localMedia.unsupported": "Sahneye JPG, PNG, MP3 veya MP4 dosyası sürükleyin ya da yapıştırın.",
  "localMedia.partiallyUnsupported": "Bazı dosyalar atlandı. Sahne JPG, PNG, MP3 ve MP4 dosyalarını kabul eder.",
  "localMedia.uploading": "Sahne medyası kaydediliyor...",
  "localMedia.uploadError": "Sahne medyası kaydedilemedi.",
  "localMedia.missingUrlError": "Backend sahne medyası URL'i döndürmedi.",

  // ── ImagePreviewModal ─────────────────────────────────────
  "imagePreview.title": "Resim Önizleme",
  "imagePreview.close": "Kapat",
  "imagePreview.altFallback": "Resim önizleme",
  "imagePreview.loadError": "Resim yüklenemedi",

  // ── ManageShortcutsModal ──────────────────────────────────
  "manageShortcuts.elementType.text": "Metin",
  "manageShortcuts.elementType.image": "Görsel",
  "manageShortcuts.elementType.choice": "Seçenek",
  "manageShortcuts.elementType.audio": "Ses",
  "manageShortcuts.elementType.dragSource": "Sürüklenebilir Öğe",
  "manageShortcuts.elementType.dropTarget": "Hedef Alan",
  "manageShortcuts.elementType.mathtype": "Matematik (MathType)",
  "manageShortcuts.elementType.mathlive": "Matematik (Legacy)",
  "manageShortcuts.confirmClearAll": "Tüm toolbar kısayollarını silmek istediğinize emin misiniz?",
  "manageShortcuts.title": "Toolbar Kısayollarını Yönet",
  "manageShortcuts.close": "Kapat",
  "manageShortcuts.emptyMessage": "Henüz toolbar'a kısayol eklemediniz.",
  "manageShortcuts.emptyHint": "Properties panelindeki 📌 ikonlarına tıklayarak kısayol ekleyebilirsiniz.",
  "manageShortcuts.clearAll": "Tümünü Temizle",
  "manageShortcuts.colorPicker": "Renk seçici",
  "manageShortcuts.toggleControl": "Açma/Kapama",
  "manageShortcuts.remove": "Kaldır",

  // ── EducationalMaterialModal ──────────────────────────────
  "educationalMaterial.titleLectureVideos": "Konu Anlatım Videoları",
  "educationalMaterial.titleSolutionTexts": "Çözüm Metinleri",
  "educationalMaterial.subtitleLectureVideo": "Bir konu anlatım videosu seçin",
  "educationalMaterial.subtitleSolutionText": "Bir çözüm metni seçin",
  "educationalMaterial.close": "Kapat",
  "educationalMaterial.searchVideoPlaceholder": "Video başlığı veya URL ara...",
  "educationalMaterial.searchFilePlaceholder": "Dosya ara...",
  "educationalMaterial.loading": "Yükleniyor...",
  "educationalMaterial.noSearchResults": "Arama sonucu bulunamadı",
  "educationalMaterial.noLectureVideos": "Konu anlatım videosu bulunamadı",
  "educationalMaterial.noSolutionTexts": "Çözüm metni bulunamadı",
  "educationalMaterial.videosTab": "Videolar",
  "educationalMaterial.filesTab": "Dosyalar",
  "educationalMaterial.cancel": "İptal",

  // ── QuestionTypeChangeConfirmModal ────────────────────────
  "questionTypeChange.title": "Soru Tipi Değişikliği",
  "questionTypeChange.irreversible": "Bu işlem geri alınamaz",
  "questionTypeChange.changeInfo": "Soru tipini değiştirmek istiyorsunuz:",
  "questionTypeChange.currentType": "Mevcut Tip",
  "questionTypeChange.notSpecified": "Belirtilmemiş",
  "questionTypeChange.newType": "Yeni Tip",
  "questionTypeChange.warning": "Uyarı",
  "questionTypeChange.warningMessage": "Bu işlem canvas içindeki tüm elementleri ve soru tipine bağlı ayarları (cevap anahtarı vb.) kalıcı olarak silecektir. Bu işlem geri alınamaz.",
  "questionTypeChange.cancel": "İptal",
  "questionTypeChange.confirmAndChange": "Onayla ve Değiştir",

  // ── FormControls ──────────────────────────────────────────
  "formControls.transparent": "Şeffaf",
  "formControls.border": "Kenarlık",
  "formControls.borderWidth": "Kalınlık",
  "formControls.color": "Renk",
  "formControls.cornerRadius": "Köşe",
  "formControls.padding": "İç Boşluk",
  "formControls.fontFamily": "Font Ailesi",
  "formControls.fontSize": "Yazı Boyutu",
  "formControls.textAlign": "Hizalama",
  "formControls.alignLeft": "Sol",
  "formControls.alignCenter": "Orta",
  "formControls.alignRight": "Sağ",
  "formControls.alignJustify": "İki Yana",
  "formControls.fontWeight": "Kalınlık",
  "formControls.fontWeightNormal": "Normal",
  "formControls.fontWeightMedium": "Orta Kalın",
  "formControls.fontWeightBold": "Kalın",
  "formControls.fontWeightExtraBold": "Ekstra Kalın",

  // ── ShortcutableControl ───────────────────────────────────
  "shortcutableControl.removeFromShortcuts": "Kısayoldan Kaldır",
  "shortcutableControl.addToToolbar": "Toolbar'a Ekle",

  // ── LayersPanel ───────────────────────────────────────────
  "layersPanel.moveUp": "Bir katman üste taşı",
  "layersPanel.moveDown": "Bir katman alta indir",

  // ── CanvasElement ─────────────────────────────────────────
  "canvasElement.fallbackContent": "Metin içeriği",

  // ── API ───────────────────────────────────────────────────
  "api.error.unknown": "Bilinmeyen hata oluştu",
  "api.media.allImages": "Tüm Görseller",
  "api.media.other": "Diğer",
  "api.audio.allSounds": "Tüm Sesler",

  // ── ElementPropertiesPanel extras ────────────────────────────
  "props.middleLeft": "Sol Orta",
  "props.middleRight": "Sağ Orta",
  "props.bottomCenter": "Alt Orta",
  "props.headerBackgroundColor": "Header Arka Plan Rengi",
  "props.tableLock": "Tabloyu Kilitle (İçindeki elemanları düzenleyebilmek için)",
  "props.showOuterBorder": "Dış Kenarlığı Göster",
  "props.outerBorder": "Dış Kenarlık (Tablo)",
  "props.showCellBorders": "Hücre Kenarlıklarını Göster",
  "props.innerBorders": "İç Kenarlıklar (Hücreler)",
  "props.alternateRowColor": "Alternatif Satır Rengi",
  "props.dimensions": "Boyutlar",
  "props.end": "Son",
  "props.viewAppearance": "Görünüm Ayarları",
  "props.noItemsAdded": "Henüz öğe eklenmemiş",
  "props.showMoreItems": "öğe daha göster",
  "props.maxUsage": "Maksimum Kullanım (0 = sınırsız)",
  "props.showLabelToggle": "Etiketi Göster",
  "props.labelText": "Etiket Metni",
  "props.hoverEffect": "Hover Efekti (Önizleme modunda)",
  "props.hoverEffectDesc": "Source ve target point'lerin üzerine gelindiğinde büyüme ve glow efekti",
  "props.allowMultipleConnections": "Birden Fazla Bağlantıya İzin Ver",
  "props.allowMultipleConnectionsDesc": "Aktif edilirse, bu source point birden fazla target point'e bağlanabilir",
  "props.sourcePointColors": "Source Point Renkleri",
  "props.connectionLine": "Bağlantı Çizgisi Ayarları",
  "props.connectionThickness": "Bağlantı Kalınlığı (px)",
  "props.showNumbersToggle": "Numaralandırma Göster",
  "props.numPosition": "Numara Pozisyonu",
  "props.itemAppearance": "Öğe Görünümü",
  "props.borderThicknessPx": "Border Kalınlığı (px)",
  "props.cornerRoundnessPct": "Köşe Yuvarlaklığı (%)",
  "props.frameSize": "Çerçeve Boyutu (px)",
  "props.maxItems": "Maksimum Öğe (0 = sınırsız)",
  "props.videoEndElements": "Video Bittikten Sonra Görünecek Elemanlar",
  "props.noOtherElements": "Başka eleman bulunamadı.",
  "props.videoElementsHelp": "Seçilen elemanlar video bitene kadar gizli kalacak, video bittikten sonra görünecektir.",
  "props.borderWidthLabel": "Kenarlık Kalınlığı",
  "props.cornerRoundness": "Köşe Yuvarlaklığı",
  "props.horizontalOuterMargin": "Yatay Dış Boşluk",
  "props.verticalOuterMargin": "Dikey Dış Boşluk",
  "props.contentPx": "İçerik (px)",
  "props.waitingState": "Beklemede",
  "props.listeningState": "Dinlerken",
  "props.errorPlaceholderHelpNew": "Bu ayar artık Canvas Durumu = Hata seçiliyken, yukarıdaki \"Yazı Alanı Placeholder\" alanından düzenleniyor.",
  "props.idAutoAssigned": "Bu ID otomatik olarak atanmıştır ve değiştirilemez",
  "props.paintAreaColorHelp": "Renk alanını bu alana sürükleyip bırakarak tüm alanı boyayabilirsiniz.",
  "props.shapeDiamond": "Elmas",
  "props.shapeOctagon": "Sekizgen",
  "props.shapeOval": "Oval",
  "props.shapeTrapezoid": "Yamuk",
  "props.shapeParallelogram": "Paralelkenar",
  "props.shapeCloud": "Bulut",
  "props.addNewItem": "+ Yeni Öğe",
  "props.sortArea": "Sıralama Alanı",
  "props.autoSizeHelpShort": "Boş bırakıldığında otomatik boyutlandırma kullanılır.",
  "props.imagePlaceholder": "Varsayılan",
  "props.optionContain": "İçer",
  "props.squareToRound": "0% = Kare, 50% = Tam Yuvarlak",
  "props.labelPosition": "Etiket Konumu",
  "props.pointSize": "Nokta Boyutu",
  "props.pointSizePx": "Nokta Boyutu (px)",
  "props.labelFontSize": "Etiket Font Boyutu",
  "props.exampleStart": "Örn: Başlat",
  "props.exampleStop": "Örn: Durdur",
  "props.elementsSelected": "öğe seçili",
  // ── MathTypeEditorModal ──────────────────────────────────
  "mathEditor.title": "Matematik Editörü (MathType)",
  "mathEditor.expression": "Matematik İfadesi",
  "mathEditor.loading": "Yükleniyor...",
  "mathEditor.cancel": "İptal",
  "mathEditor.save": "Kaydet",

  "props.kenarlıkStili": "Kenarlık Stili",
  "props.kenarlıkYuvarlak": "Kenarlık Yuvarlaklığı",
  "props.icBoslukYatay": "İç Boşluk (Yatay)",
  "props.icBoslukDikey": "İç Boşluk (Dikey)",
  "props.icerikDuzeni": "İçerik Düzeni",
  "props.icerikHizalama": "İçerik Hizalaması",

  // ── SettingsModal ───────────────────────────────────────
  "settings.title": "Ayarlar",
  "settings.subtitle": "Canvas ve grid seçeneklerini burada düzenleyin.",
  "settings.close": "Kapat",
  "settings.canvasOuterPadding": "Canvas Dış Boşluk",
  "settings.canvasInnerPadding": "Canvas İç Boşluk",
  "settings.leftPx": "Sol (px)",
  "settings.topPx": "Üst (px)",
  "settings.rightPx": "Sağ (px)",
  "settings.bottomPx": "Alt (px)",
  "settings.grid": "Izgara",
  "settings.showGrid": "Izgarayı göster",
  "settings.cellSizePx": "Hücre boyutu (px)",
  "settings.backgroundSection": "Arka Plan",
  "settings.colorLabel": "Renk",
  "settings.transparent": "Şeffaf",
  "settings.resetToDefaults": "Varsayılanlara Dön",
  "settings.cancel": "İptal",
  "settings.save": "Kaydet",

  // ── SaveSuccessModal ────────────────────────────────────
  "saveSuccess.title": "Kayıt Başarılı!",
  "saveSuccess.continueEditing": "Editörde Devam Et",
  "saveSuccess.continueEditingDesc": "Soruyu düzenlemeye devam edin",
  "saveSuccess.goToQuestions": "Sorulara Dön",
  "saveSuccess.goToQuestionsDesc": "Soru listesine geri dönün",

  // ── RichTextEditor ──────────────────────────────────────
  "richTextEditor.hint": "Sağ tıkla veya ⌘B/I/U",

  // ── QuestionTypeChangeConfirmModal extras ───────────────
  "questionTypeChange.elementCount": "Canvas içinde {count} adet element bulunmaktadır.",

  // ── Validation extras ───────────────────────────────────
  "validation.score": "Puanınız: {score}/{maxScore} (%{percentage})",
  "validation.correctCountSummary": "{correctCount}/{totalCount} soruyu doğru yanıtladınız.",
  "validation.dragDrop.exactCountRequired": "Tam olarak {count} öğe olmalı (Şu an: {current})",
  "validation.dragDrop.minItemsRequired": "En az {count} öğe olmalı (Şu an: {current})",
  "validation.dragDrop.maxItemsExceeded": "En fazla {count} öğe olmalı (Şu an: {current})",
  "validation.orderList.wrongItemCount": "Öğe sayısı yanlış. Doğru sayı: {correct}, Sizin sayınız: {current}",
  "validation.partialCreditSuffix": "puan",
  "validation.partialPositionHint": "Bazı öğeler doğru konumda",

  // ── QuestionSettingsModal extras ────────────────────────
  "questionSettings.timeLimitPlaceholder": "Örn. 120",

  // ── ErrorBoundary ───────────────────────────────────────
  "errorBoundary.title": "Bir hata oluştu",
};
